<template>
  <Navbar />
  <MastHero v-on:copyToClipboard="copyToClipboard" />
  <SectionSummary />
  <SectionPhone />
  <SectionTelecom />
  <SectionFeatures />
  <SectionDemo />
  <SectionExclusive />
  <SectionFAQ />
  <SectionShare v-on:copyToClipboard="copyToClipboard" />
  <SectionFooter />
  <transition name="slide">
    <ClipboardAlert 
      v-if="showClipboardAlert" 
      v-on:close="showClipboardAlert = false"
    />
  </transition>
</template>

<script>
import Navbar from '@/components/nav/Navbar'
import MastHero from "@/components/mast/MastHero"
import SectionSummary from "@/components/section/SectionSummary"
import SectionPhone from "@/components/section/SectionPhone"
import SectionFeatures from "@/components/section/SectionFeatures"
import SectionDemo from "@/components/section/SectionDemo"
import SectionTelecom from "@/components/section/SectionTelecom"
import SectionExclusive from "@/components/section/SectionExclusive"
import SectionFAQ from "@/components/section/SectionFAQ"
import SectionShare from "@/components/section/SectionShare"
import SectionFooter from "@/components/section/SectionFooter"
import ClipboardAlert from "@/components/ClipboardAlert"
import 'normalize.css'

export default {
  name: 'App',
  data() {
    return {
      showClipboardAlert: false,
      showClipboardTime: new Date().getTime()
    }
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  methods: {
    copyToClipboard() {
      if (navigator.share) {
        navigator.share({
          url: window.location
        })
      } else {
        const time = new Date().getTime()
        this.showClipboardTime = time
        this.showClipboardAlert = true
        navigator.clipboard.writeText(window.location)
        setTimeout(()=> {
          if (this.showClipboardTime === time) {
            this.showClipboardAlert = false
            this.showClipboardTime = false
          }
        }, 3000)
      }
    }
  },
  components: {
    MastHero,
    SectionSummary,
    SectionPhone,
    SectionFeatures,
    SectionDemo,
    SectionTelecom,
    SectionExclusive,
    SectionFAQ,
    SectionShare,
    SectionFooter,
    Navbar,
    ClipboardAlert
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;500;700&display=swap');

* {
  margin: 0;
  padding: 0;
  word-break: keep-all;
}

html,
body {
  // overflow: hidden;
  font-family: 'Noto Sans KR', sans-serif;
  letter-spacing: -0.02em;
  width: 100%;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

*, *:before, *:after {
  box-sizing: border-box;
}

button {
  cursor: pointer !important;
}


.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s ease;
}
.slide-enter-from,
.slide-leave-to {
  opacity: 0;
  transform: translate3d(0, 50%, 0);
}

</style>
